<!--<app-header></app-header>-->

<!--<div class="page-container">-->

<!--  &lt;!&ndash; Page content &ndash;&gt;-->
<!--  <div class="page-content">-->

<!--    <div class="panel panel-flat">-->

<!--      <div class="panel-heading">-->
<!--        <div class="col-lg-4">-->
<!--          <h5 class="panel-title">-->
<!--            <strong>{{headingTitle}}</strong>-->
<!--          </h5>-->
<!--        </div>-->

<!--        <div class="col-lg-8 navbar">-->

<!--          <div class="navbar-header col-lg-4 col-md-4 col-sm-12 col-xs-12">-->
<!--            <ul class="nav navbar-nav pull-right visible-xs-block">-->
<!--              <li><a data-toggle="collapse" data-target="#navbar-industry-update-toggle"><i class="icon-tree5"></i></a></li>-->
<!--            </ul>-->
<!--          </div>-->

<!--            <div class="navbar-collapse pull-right collapse" style="width: 100%; margin-top: -1%;" id="navbar-industry-update-toggle">-->
<!--              <ul class="nav navbar-nav pull-right" style="width: 100%;">-->
<!--                <li [ngClass]="{'active': editView== 'industry'}"><a [ngClass]="{'active-link': editView== 'industry','no-link': editView!= 'industry'}" (click)="switchView('industry')"> Industry Detail</a></li>-->
<!--                <li [ngClass]="{'active': editView== 'station'}"><a [ngClass]="{'active-link': editView== 'station','no-link': editView!= 'station'}" (click)="switchView('station')"> Station Detail</a></li>-->
<!--                <li [ngClass]="{'active': editView== 'device'}"><a [ngClass]="{'active-link': editView== 'device','no-link': editView!= 'device'}" (click)="switchView('device')"> Device Detail</a></li>-->
<!--                <li [ngClass]="{'active': editView== 'parameter'}"><a [ngClass]="{'active-link': editView== 'parameter','no-link': editView!= 'parameter'}" (click)="switchView('parameter')"> Parameter Detail</a></li>-->
<!--                <li *ngIf="type == 'edit'" [ngClass]="{'active': editView== 'add'}"><a [ngClass]="{'active-link': editView== 'add','no-link': editView!= 'add'}" (click)="switchView('add')"> Add New</a></li>-->
<!--              </ul>-->
<!--            </div>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div class="clearfix"></div>-->

<!--      <div class="panel-body" *ngIf="editView == 'industry'">-->

<!--        <div class="col-lg-12 text-center" *ngIf="getIndustryDetailLoader" style="margin-top: 50px;">-->
<!--          <img src="/assets/images/load.gif" />-->
<!--        </div>-->

<!--        <div class="form-horizontal" *ngIf="!getIndustryDetailLoader">-->

<!--          <fieldset class="content-group">-->
<!--            <div class="form-group">-->
<!--              <label class="control-label col-lg-2">Category Type*</label>-->
<!--              <div class="col-lg-10">-->
<!--                <input autocomplete="off" pattern="^[^<>]*$" type="text" [disabled]="(type == 'view')?true:false" [(ngModel)]="indDetails['industry_category']" placeholder="Enter Category Type" class="form-control">-->
<!--                <div *ngIf="formErrorCategory && error">-->
<!--                  <span style=" margin-left: 5px; color: red; font-weight: 900;">*{{formErrorCategory}}</span>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->

<!--            <div class="form-group">-->
<!--              <label class="control-label col-lg-2">Category Name*</label>-->
<!--              <div class="col-lg-10">-->
<!--                <input autocomplete="off" pattern="^[^<>]*$" type="text" [disabled]="(type == 'view')?true:false" [(ngModel)]="indDetails['industry_type']" placeholder="Enter Category Name" class="form-control">-->
<!--                <div *ngIf="formErrorCategoryType && error">-->
<!--                  <span style=" margin-left: 5px; color: red; font-weight: 900;">*{{formErrorCategoryType}}</span>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->

<!--            <div class="form-group">-->
<!--              <label class="control-label col-lg-2">-->
<!--                Industry Code-->
<!--                <div class="text-muted">(as assigned by CPCB)</div>-->
<!--              </label>-->
<!--              <div class="col-lg-10">-->
<!--                <input autocomplete="off" pattern="^[^<>]*$" type="text" [disabled]="(type == 'view')?true:false" [(ngModel)]="indDetails['code']" placeholder="Enter Industry Code" class="form-control">-->
<!--                <div *ngIf="formErrorCode && error">-->
<!--                  <span style=" margin-left: 5px; color: red; font-weight: 900;">*{{formErrorCode}}</span>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->

<!--            <div class="form-group">-->
<!--              <label class="control-label col-lg-2">-->
<!--                Industry Id*-->
<!--                <div class="text-muted">(as maintained in vendor system)</div>-->
<!--              </label>-->
<!--              <div class="col-lg-10">-->
<!--                <input autocomplete="off" pattern="^[^<>]*$" type="text" [disabled]="(type == 'view')?true:false" [(ngModel)]="indDetails['vendor_ind_id']" placeholder="Enter Industry Id" class="form-control">-->
<!--                <div *ngIf="formErrorVendorId && error">-->
<!--                  <span style=" margin-left: 5px; color: red; font-weight: 900;">*{{formErrorVendorId}}</span>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->

<!--            <div class="form-group">-->
<!--              <label class="control-label col-lg-2">-->
<!--                Industry Name*-->
<!--              </label>-->
<!--              <div class="col-lg-10">-->
<!--                <input autocomplete="off" pattern="^[^<>]*$" type="text" [disabled]="(type == 'view')?true:false" [(ngModel)]="indDetails['name']" placeholder="Enter Industry Name" class="form-control">-->
<!--                <div *ngIf="formErrorIndName && error">-->
<!--                  <span style=" margin-left: 5px; color: red; font-weight: 900;">*{{formErrorIndName}}</span>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->

<!--            <div class="form-group">-->
<!--              <label class="control-label col-lg-2">-->
<!--                Address*-->
<!--              </label>-->
<!--              <div class="col-lg-10">-->
<!--                <input autocomplete="off" pattern="^[^<>]*$" type="text" [disabled]="(type == 'view')?true:false" [(ngModel)]="indDetails['address']" placeholder="Enter Address" class="form-control">-->
<!--                <div *ngIf="formErrorAddress && error">-->
<!--                  <span style=" margin-left: 5px; color: red; font-weight: 900;">*{{formErrorAddress}}</span>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->

<!--            <div class="form-group">-->
<!--              <label class="control-label col-lg-2">-->
<!--                SPCB Regional Office-->
<!--              </label>-->
<!--              <div class="col-lg-10">-->
<!--                <input autocomplete="off" pattern="^[^<>]*$" type="text" [disabled]="(type == 'view')?true:false" [(ngModel)]="indDetails['spcb_regional_office']" placeholder="Enter SPCB Regional Office" class="form-control">-->
<!--              </div>-->
<!--            </div>-->

<!--            <div class="form-group">-->
<!--              <label class="control-label col-lg-2">-->
<!--                City*-->
<!--              </label>-->
<!--              <div class="col-lg-10">-->
<!--                <input autocomplete="off" pattern="^[^<>]*$" type="text" [disabled]="(type == 'view')?true:false" [(ngModel)]="indDetails['city']" placeholder="Enter City" class="form-control">-->
<!--                <div *ngIf="formErrorCity && error">-->
<!--                  <span style=" margin-left: 5px; color: red; font-weight: 900;">*{{formErrorCity}}</span>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->

<!--            <div class="form-group">-->
<!--              <label class="control-label col-lg-2">-->
<!--                Zip Code*-->
<!--              </label>-->
<!--              <div class="col-lg-10">-->
<!--                <input autocomplete="off" pattern="^[^<>]*$" type="number" [disabled]="(type == 'view')?true:false" onkeypress="return event.charCode >= 48 && event.charCode <= 57" [(ngModel)]="indDetails['zip']" placeholder="Enter Zip Code" class="form-control">-->
<!--                <div *ngIf="formErrorZip && error">-->
<!--                  <span style=" margin-left: 5px; color: red; font-weight: 900;">*{{formErrorZip}}</span>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->

<!--            <div class="form-group">-->
<!--              <label class="control-label col-lg-2">-->
<!--                Latitude*-->
<!--              </label>-->
<!--              <div class="col-lg-10">-->
<!--                <input type="number" [disabled]="(type == 'view')?true:false" onkeypress="return event.charCode <= 57"  [(ngModel)]="indDetails['latitude']" placeholder="Enter Latitude" class="form-control">-->
<!--                <div *ngIf="formErrorLat && error">-->
<!--                  <span style=" margin-left: 5px; color: red; font-weight: 900;">*{{formErrorLat}}</span>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->

<!--            <div class="form-group">-->
<!--              <label class="control-label col-lg-2">-->
<!--                Longitude*-->
<!--              </label>-->
<!--              <div class="col-lg-10">-->
<!--                <input type="number" [disabled]="(type == 'view')?true:false" onkeypress="return event.charCode <= 57" [(ngModel)]="indDetails['longitude']" placeholder="Enter Longitude" class="form-control">-->
<!--                <div *ngIf="formErrorLong && error">-->
<!--                  <span style=" margin-left: 5px; color: red; font-weight: 900;">*{{formErrorLong}}</span>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->

<!--            <div class="form-group">-->
<!--              <label class="control-label col-lg-2">-->
<!--                OCMMS Id*-->
<!--              </label>-->
<!--              <div class="col-lg-10">-->
<!--                <input type="text" [disabled]="(type == 'view')?true:false" [(ngModel)]="indDetails['hr_ocmms_id']" placeholder="Enter OCMMS Id" class="form-control">-->
<!--                <div *ngIf="formErrorOcmmsId && error">-->
<!--                  <span style=" margin-left: 5px; color: red; font-weight: 900;">*{{formErrorOcmmsId}}</span>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->

<!--            <div class="form-group">-->
<!--              <label class="control-label col-lg-2">-->
<!--                Monitoring Type*-->
<!--              </label>-->
<!--              <div class="col-lg-10">-->
<!--                <select [disabled]="(type == 'view')?true:false" [(ngModel)]="indDetails['emmision_type']" class="form-control">-->
<!--                  <option value="air"> Air </option>-->
<!--                  <option value="water"> Water </option>-->
<!--                  <option value="both"> Both </option>-->
<!--                </select>-->

<!--                <div *ngIf="formErrorMonitoringType && error">-->
<!--                  <span style=" margin-left: 5px; color: red; font-weight: 900;">*{{formErrorMonitoringType}}</span>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->

<!--            <div class="form-group">-->
<!--              <label class="control-label col-lg-2">-->
<!--                Officer*-->
<!--              </label>-->
<!--              <div class="col-lg-10">-->
<!--                <select [disabled]="(type == 'view')?true:false" [(ngModel)]="indDetails['regional_officer_id']" class="form-control">-->
<!--                  <option value=""> Select Officer </option>-->
<!--                  <option *ngFor="let officer of officerList let i = index" [attr.data-index]="i" value="{{officer.id}}">{{officer.name}} ({{officer.region_name}})</option>-->
<!--                </select>-->

<!--                <div *ngIf="formErrorOfficer && error">-->
<!--                  <span style=" margin-left: 5px; color: red; font-weight: 900;">*{{formErrorOfficer}}</span>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->

<!--            <div class="form-group">-->
<!--              <label class="control-label col-lg-2">-->
<!--                Contact Person Name-->
<!--              </label>-->
<!--              <div class="col-lg-10">-->
<!--                <input type="text" [disabled]="(type == 'view')?true:false" [(ngModel)]="indDetails['contact_person']" placeholder="Enter Contact Person Name" class="form-control">-->
<!--                <div *ngIf="formErrorContactPersonName && error">-->
<!--                  <span style=" margin-left: 5px; color: red; font-weight: 900;">*{{formErrorContactPersonName}}</span>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->

<!--            <div class="form-group">-->
<!--              <label class="control-label col-lg-2">-->
<!--                Contact Person Designation-->
<!--              </label>-->
<!--              <div class="col-lg-10">-->
<!--                <input type="text"  [disabled]="(type == 'view')?true:false" [(ngModel)]="indDetails['contact_person_designation']" placeholder="Enter Contact Person Designation" class="form-control">-->
<!--                <div *ngIf="formErrorContactPersonDesignation && error">-->
<!--                  <span style=" margin-left: 5px; color: red; font-weight: 900;">*{{formErrorContactPersonDesignation}}</span>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->

<!--            <div class="form-group">-->
<!--              <label class="control-label col-lg-2">-->
<!--                Contact Person Email-->
<!--              </label>-->
<!--              <div class="col-lg-10">-->
<!--                <input type="email" [disabled]="(type == 'view')?true:false" [(ngModel)]="indDetails['contact_email']" placeholder="Enter Contact Person Email" class="form-control">-->
<!--                <div *ngIf="formErrorContactPersonEmail && error">-->
<!--                  <span style=" margin-left: 5px; color: red; font-weight: 900;">*{{formErrorContactPersonEmail}}</span>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->

<!--            <div class="form-group">-->
<!--              <label class="control-label col-lg-2">-->
<!--                Contact Person Mobile Number-->
<!--              </label>-->
<!--              <div class="col-lg-10">-->
<!--                <input [disabled]="(type == 'view')?true:false" type="number" onkeypress="return event.charCode >= 48 && event.charCode <= 57" [(ngModel)]="indDetails['contact_number']" placeholder="Enter Contact Person Mobile Number" class="form-control">-->
<!--                <div *ngIf="formErrorContactPersonMobile && error">-->
<!--                  <span style=" margin-left: 5px; color: red; font-weight: 900;">*{{formErrorContactPersonMobile}}</span>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="form-group">-->
<!--              <label class="control-label col-lg-2">-->
<!--                WebCam Url-->
<!--              </label>-->
<!--              &lt;!&ndash; onkeypress="return event.charCode >= 48 && event.charCode <= 57" &ndash;&gt;-->
<!--              <div class="col-lg-10">-->
<!--                <input [disabled]="(type == 'view')?true:false" type="text"-->
<!--                       [(ngModel)]="indDetails['web_cam_url']" placeholder="Enter WebCam Url"-->
<!--                       class="form-control">-->
<!--                <div *ngIf="error">-->
<!--                  <span-->
<!--                    style=" margin-left: 5px; color: red; font-weight: 900;"></span>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->

<!--            <div class="form-group" *ngIf="type == 'edit'">-->
<!--              <div class="col-lg-12" *ngIf="!updateIndLoader">-->

<!--                <div class="col-lg-1 pull-right">-->
<!--                  <button (click)="validateIndustry()" type="submit" class="btn btn-primary">-->
<!--                    <strong>Update</strong>-->
<!--                  </button>-->
<!--                </div>-->

<!--                <div class="col-lg-1 pull-right">-->
<!--                  <button (click)="getIndustryDetail()" type="button" class="btn btn-danger">-->
<!--                    <strong>Reset</strong>-->
<!--                  </button>-->
<!--                </div>-->
<!--              </div>-->

<!--              <div class="col-lg-12" *ngIf="updateIndLoader">-->
<!--                <span class="pull-right"><img style="width: 60%;" src="/assets/images/load.gif" /></span>-->
<!--              </div>-->

<!--            </div>-->
<!--          </fieldset>-->
<!--        </div>-->
<!--      </div>-->

<!--    </div>-->

<!--    <app-update-station-detail [industryId]="industryId" [type]="type" *ngIf="editView == 'station'"></app-update-station-detail>-->
<!--    <app-update-device-detail [industryId]="industryId" [type]="type" *ngIf="editView == 'device'"></app-update-device-detail>-->
<!--    <app-update-parameter-detail [industryId]="industryId" [type]="type" *ngIf="editView == 'parameter'"></app-update-parameter-detail>-->
<!--    <app-add-details-existing-industry [industryId]="industryId" *ngIf="editView == 'add'"></app-add-details-existing-industry>-->

<!--  </div>-->

<!--</div>-->

<!--<app-footer></app-footer>-->

<app-header></app-header>

<div class="container-fluid">
  <!-- Page content -->
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header d-flex align-items-center">
          <div class="col-lg-4">
            <h5 class="card-title mb-0">
              <strong>{{headingTitle}}</strong>
            </h5>
          </div>

          <div class="col-lg-8">
            <nav class="navbar navbar-expand-lg p-0">
              <button class="navbar-toggler ms-auto d-lg-none" type="button" data-bs-toggle="collapse" data-bs-target="#navbar-industry-update-toggle">
                <i class="icon-tree5"></i>
              </button>

              <div class="collapse navbar-collapse" id="navbar-industry-update-toggle">
                <ul class="navbar-nav ms-auto">
                  <li class="" [ngClass]="{'active': editView== 'industry'}">
                    <a class="nav-link" [ngClass]="{'active-link': editView== 'industry','no-link': editView!= 'industry'}"
                       (click)="switchView('industry')">Industry Detail</a>
                  </li>
                  <li class="" [ngClass]="{'active': editView== 'station'}">
                    <a class="nav-link" [ngClass]="{'active-link': editView== 'station','no-link': editView!= 'station'}"
                       (click)="switchView('station')">Station Detail</a>
                  </li>
                  <li class="" [ngClass]="{'active': editView== 'device'}">
                    <a class="nav-link" [ngClass]="{'active-link': editView== 'device','no-link': editView!= 'device'}"
                       (click)="switchView('device')">Device Detail</a>
                  </li>
                  <li class="" [ngClass]="{'active': editView== 'parameter'}">
                    <a class="nav-link" [ngClass]="{'active-link': editView== 'parameter','no-link': editView!= 'parameter'}"
                       (click)="switchView('parameter')">Parameter Detail</a>
                  </li>
                  <li class="" *ngIf="type == 'edit'" [ngClass]="{'active': editView== 'add'}">
                    <a class="nav-link" [ngClass]="{'active-link': editView== 'add','no-link': editView!= 'add'}"
                       (click)="switchView('add')">Add New</a>
                  </li>
                </ul>
              </div>
            </nav>
          </div>
        </div>

        <div class="card-body" *ngIf="editView == 'industry'">
          <div class="text-center py-5" *ngIf="getIndustryDetailLoader">
            <img src="/assets/images/load.gif" />
          </div>

          <div class="row" *ngIf="!getIndustryDetailLoader">
            <div class="col-lg-6">
              <div class="mb-3">
                <label class="form-label">Category Type*</label>
                <input autocomplete="off" pattern="^[^<>]*$" type="text"
                       [disabled]="type == 'view'"
                       [(ngModel)]="indDetails['industry_category']"
                       placeholder="Enter Category Type"
                       class="form-control">
                <div *ngIf="formErrorCategory && error" class="text-danger fw-bold mt-1">
                  *{{formErrorCategory}}
                </div>
              </div>

              <div class="mb-3">
                <label class="form-label">Category Name*</label>
                <input autocomplete="off" pattern="^[^<>]*$" type="text"
                       [disabled]="type == 'view'"
                       [(ngModel)]="indDetails['industry_type']"
                       placeholder="Enter Category Name"
                       class="form-control">
                <div *ngIf="formErrorCategoryType && error" class="text-danger fw-bold mt-1">
                  *{{formErrorCategoryType}}
                </div>
              </div>

              <div class="mb-3">
                <label class="form-label">
                  Industry Code
                  <span class="text-muted d-block">(as assigned by CPCB)</span>
                </label>
                <input autocomplete="off" pattern="^[^<>]*$" type="text"
                       [disabled]="type == 'view'"
                       [(ngModel)]="indDetails['code']"
                       placeholder="Enter Industry Code"
                       class="form-control">
                <div *ngIf="formErrorCode && error" class="text-danger fw-bold mt-1">
                  *{{formErrorCode}}
                </div>
              </div>

              <div class="mb-3">
                <label class="form-label">
                  Industry Id*
                  <span class="text-muted d-block">(as maintained in vendor system)</span>
                </label>
                <input autocomplete="off" pattern="^[^<>]*$" type="text"
                       [disabled]="type == 'view'"
                       [(ngModel)]="indDetails['vendor_ind_id']"
                       placeholder="Enter Industry Id"
                       class="form-control">
                <div *ngIf="formErrorVendorId && error" class="text-danger fw-bold mt-1">
                  *{{formErrorVendorId}}
                </div>
              </div>

              <div class="mb-3">
                <label class="form-label">Industry Name*</label>
                <input autocomplete="off" pattern="^[^<>]*$" type="text"
                       [disabled]="type == 'view'"
                       [(ngModel)]="indDetails['name']"
                       placeholder="Enter Industry Name"
                       class="form-control">
                <div *ngIf="formErrorIndName && error" class="text-danger fw-bold mt-1">
                  *{{formErrorIndName}}
                </div>
              </div>

              <div class="mb-3">
                <label class="form-label">Address*</label>
                <input autocomplete="off" pattern="^[^<>]*$" type="text"
                       [disabled]="type == 'view'"
                       [(ngModel)]="indDetails['address']"
                       placeholder="Enter Address"
                       class="form-control">
                <div *ngIf="formErrorAddress && error" class="text-danger fw-bold mt-1">
                  *{{formErrorAddress}}
                </div>
              </div>

              <div class="mb-3">
                <label class="form-label">SPCB Regional Office</label>
                <input autocomplete="off" pattern="^[^<>]*$" type="text"
                       [disabled]="type == 'view'"
                       [(ngModel)]="indDetails['spcb_regional_office']"
                       placeholder="Enter SPCB Regional Office"
                       class="form-control">
              </div>
            </div>

            <div class="col-lg-6">
              <div class="mb-3">
                <label class="form-label">City*</label>
                <input autocomplete="off" pattern="^[^<>]*$" type="text"
                       [disabled]="type == 'view'"
                       [(ngModel)]="indDetails['city']"
                       placeholder="Enter City"
                       class="form-control">
                <div *ngIf="formErrorCity && error" class="text-danger fw-bold mt-1">
                  *{{formErrorCity}}
                </div>
              </div>

              <div class="mb-3">
                <label class="form-label">Zip Code*</label>
                <input autocomplete="off" pattern="^[^<>]*$" type="number"
                       [disabled]="type == 'view'"
                       onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                       [(ngModel)]="indDetails['zip']"
                       placeholder="Enter Zip Code"
                       class="form-control">
                <div *ngIf="formErrorZip && error" class="text-danger fw-bold mt-1">
                  *{{formErrorZip}}
                </div>
              </div>

              <div class="mb-3">
                <label class="form-label">Latitude*</label>
                <input type="number"
                       [disabled]="type == 'view'"
                       onkeypress="return event.charCode <= 57"
                       [(ngModel)]="indDetails['latitude']"
                       placeholder="Enter Latitude"
                       class="form-control">
                <div *ngIf="formErrorLat && error" class="text-danger fw-bold mt-1">
                  *{{formErrorLat}}
                </div>
              </div>

              <div class="mb-3">
                <label class="form-label">Longitude*</label>
                <input type="number"
                       [disabled]="type == 'view'"
                       onkeypress="return event.charCode <= 57"
                       [(ngModel)]="indDetails['longitude']"
                       placeholder="Enter Longitude"
                       class="form-control">
                <div *ngIf="formErrorLong && error" class="text-danger fw-bold mt-1">
                  *{{formErrorLong}}
                </div>
              </div>

              <div class="mb-3">
                <label class="form-label">OCMMS Id*</label>
                <input type="text"
                       [disabled]="type == 'view'"
                       [(ngModel)]="indDetails['hr_ocmms_id']"
                       placeholder="Enter OCMMS Id"
                       class="form-control">
                <div *ngIf="formErrorOcmmsId && error" class="text-danger fw-bold mt-1">
                  *{{formErrorOcmmsId}}
                </div>
              </div>

              <div class="mb-3">
                <label class="form-label">Monitoring Type*</label>
                <select [disabled]="type == 'view'"
                        [(ngModel)]="indDetails['emmision_type']"
                        class="form-select">
                  <option value="air">Air</option>
                  <option value="water">Water</option>
                  <option value="both">Both</option>
                </select>
                <div *ngIf="formErrorMonitoringType && error" class="text-danger fw-bold mt-1">
                  *{{formErrorMonitoringType}}
                </div>
              </div>

              <div class="mb-3">
                <label class="form-label">Officer*</label>
                <select [disabled]="type == 'view'"
                        [(ngModel)]="indDetails['regional_officer_id']"
                        class="form-select">
                  <option value="">Select Officer</option>
                  <option *ngFor="let officer of officerList let i = index"
                          [attr.data-index]="i"
                          value="{{officer.id}}">
                    {{officer.name}} ({{officer.region_name}})
                  </option>
                </select>
                <div *ngIf="formErrorOfficer && error" class="text-danger fw-bold mt-1">
                  *{{formErrorOfficer}}
                </div>
              </div>
            </div>

            <div class="col-lg-6">
              <div class="mb-3">
                <label class="form-label">Contact Person Name</label>
                <input type="text"
                       [disabled]="type == 'view'"
                       [(ngModel)]="indDetails['contact_person']"
                       placeholder="Enter Contact Person Name"
                       class="form-control">
                <div *ngIf="formErrorContactPersonName && error" class="text-danger fw-bold mt-1">
                  *{{formErrorContactPersonName}}
                </div>
              </div>

              <div class="mb-3">
                <label class="form-label">Contact Person Designation</label>
                <input type="text"
                       [disabled]="type == 'view'"
                       [(ngModel)]="indDetails['contact_person_designation']"
                       placeholder="Enter Contact Person Designation"
                       class="form-control">
                <div *ngIf="formErrorContactPersonDesignation && error" class="text-danger fw-bold mt-1">
                  *{{formErrorContactPersonDesignation}}
                </div>
              </div>
            </div>

            <div class="col-lg-6">
              <div class="mb-3">
                <label class="form-label">Contact Person Email</label>
                <input type="email"
                       [disabled]="type == 'view'"
                       [(ngModel)]="indDetails['contact_email']"
                       placeholder="Enter Contact Person Email"
                       class="form-control">
                <div *ngIf="formErrorContactPersonEmail && error" class="text-danger fw-bold mt-1">
                  *{{formErrorContactPersonEmail}}
                </div>
              </div>

              <div class="mb-3">
                <label class="form-label">Contact Person Mobile Number</label>
                <input [disabled]="type == 'view'"
                       type="number"
                       onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                       [(ngModel)]="indDetails['contact_number']"
                       placeholder="Enter Contact Person Mobile Number"
                       class="form-control">
                <div *ngIf="formErrorContactPersonMobile && error" class="text-danger fw-bold mt-1">
                  *{{formErrorContactPersonMobile}}
                </div>
              </div>
            </div>


            <div class="col-lg-6">

              <div class="mb-3">
                <label class="form-label">WebCam Url</label>
                <input [disabled]="type == 'view'"
                       type="text"
                       [(ngModel)]="indDetails['web_cam_url']"
                       placeholder="Enter WebCam Url"
                       class="form-control">
              </div>

              <div class="mb-3">
                <label class="form-label">DJB Industry Type</label>
                <select [disabled]="type == 'view'"
                        [(ngModel)]="indDetails['djb_industry_type']"
                        class="form-select">
                  <option value="djbcetp">DJB CETP</option>
                  <option value="djbstp">DJB STP</option>
                  <option value="other">Other</option>
                </select>

              </div>

            </div>
            <div class="col-lg-6">
              <div class="mb-3">
                <label class="form-label">WebCam Username</label>
                <input [disabled]="type == 'view'"
                      type="text"
                      [(ngModel)]="indDetails['webcam_user_name']"
                      placeholder="Enter WebCam Username"
                      class="form-control">
              </div>

             <div class="mb-3">
  <label class="form-label">WebCam Password</label>

  <div class="input-group">
    <input
      [disabled]="type == 'view'"
      [type]="showWebcamPassword ? 'text' : 'password'"
      [(ngModel)]="indDetails['webcam_password']"
      placeholder="Enter WebCam Password"
      class="form-control">

    <button
      type="button"
      class="btn btn-outline-secondary"
      (click)="showWebcamPassword = !showWebcamPassword">
      <i class="fa"
        [ngClass]="showWebcamPassword ? 'fa-eye-slash' : 'fa-eye'">
      </i>
    </button>
  </div>
</div>
            </div>

            <div class="col-12" *ngIf="type == 'edit'">
              <div class="d-flex justify-content-end gap-2">
                <button (click)="getIndustryDetail()" type="button" class="btn btn-danger">
                  <strong>Reset</strong>
                </button>
                <button (click)="validateIndustry()" type="submit" class="btn btn-primary" [disabled]="updateIndLoader">
                  <span *ngIf="!updateIndLoader"><strong>Update</strong></span>
                  <span *ngIf="updateIndLoader"><img style="width: 60%;" src="/assets/images/load.gif" /></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <app-update-station-detail [industryId]="industryId" [type]="type" *ngIf="editView == 'station'"></app-update-station-detail>
      <app-update-device-detail [industryId]="industryId" [type]="type" *ngIf="editView == 'device'"></app-update-device-detail>
      <app-update-parameter-detail [industryId]="industryId" [type]="type" *ngIf="editView == 'parameter'"></app-update-parameter-detail>
      <app-add-details-existing-industry [industryId]="industryId" *ngIf="editView == 'add'"></app-add-details-existing-industry>
    </div>
  </div>
</div>

<app-footer></app-footer>
